export const GENDER_OPTIONS = [
  {
    value: "male",
    description: "Male",
  },
  {
    value: "female",
    description: "Female",
  },
];

export const MARITAL_STATUS_OPTIONS = [
  {
    value: "single",
    description: "Single",
  },
  {
    value: "married",
    description: "Married",
  },
  {
    value: "divorced",
    description: "Divorced",
  },
  {
    value: "widowed",
    description: "Widowed",
  },
  {
    value: "registered_partner",
    description: "Registered Partner",
  },
];

export const EDUCATION_LEVEL_OPTIONS = [
  {
    value: "basic",
    description: "Basic Education (Põhiharidus)",
  },
  {
    value: "secondary",
    description: "Secondary Education (Üldkeskharidus / Gümnaasium)",
  },
  {
    value: "vocational_secondary",
    description: "Vocational Secondary Education (Kutsekeskharidus)",
  },
  {
    value: "applied_higher",
    description:
      "Applied Higher Education / Professional Higher Education (Rakenduskõrgharidus)",
  },
  {
    value: "bachelors",
    description: "Bachelor's Degree (Bakalaureusekraad)",
  },
  {
    value: "masters",
    description: "Master's Degree (Magistrikraad)",
  },
  {
    value: "doctorate",
    description: "Doctorate / PhD (Doktorikraad)",
  },
  {
    value: "postdoctoral",
    description: "Postdoctoral Studies",
  },
  {
    value: "in_progress",
    description: "In Progress (currently enrolled in a program)",
  },
  {
    value: "none",
    description: "None",
  },
];
